export default "__VITE_ASSET__9bbf5252__"